module.exports = __webpack_public_path__ + "static/media/ขาล.ac9e9bed.jpg";